import { APIS } from 'config';
import { boolean, object, string } from 'yup';

const REFRESH_TIME = 2000;

const responseSchema = object({
  error: string().nullable(),
  success: boolean().default(true),
  taskId: string().required()
});

export const handleLongPullResponse = async (
  response: Response,
  tenantGuid: string,
  {
    onSuccess,
    onError
  }: {
    onSuccess: (taskId: string) => Promise<void>;
    onError: (error: string) => void;
  }
) => {
  const { error, success, taskId } = await responseSchema.validate(await response.json());

  if (error || !success) {
    console.error('fix failed');
    onError(error || '');
    return;
  }
  await waitingForTaskComplete(taskId, tenantGuid, {
    onSuccess,
    onError
  });
};

const waitingForTaskComplete = async (
  taskId: string,
  tenantGuid: string,
  {
    onSuccess,
    onError
  }: {
    onSuccess: (taskId: string) => Promise<void>;
    onError: (error: string) => void;
  }
) => {
  return new Promise<void>((resolve, reject) => {
    const intervalTask = setInterval(async () => {
      const response = await fetch(`${APIS.SSPM}/api/get-task?taskId=${taskId}&tenantGuid=${tenantGuid}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      });
      const { completed, error } = await response.json();
      if (completed) {
        await onSuccess(taskId);
        clearInterval(intervalTask);
        resolve();
      }
      if (error) {
        onError(error);
        clearInterval(intervalTask);
        reject();
      }
    }, REFRESH_TIME);
  });
};
